import React, { useDebugValue, useEffect, useState } from "react";
import { Styles } from "react-modal";
import { Moment } from "moment";
import {
    combineLogs,
    setLogsStartDate,
    setLogsEndDate,
    setLogsTickerName,
    getLogs,
} from "store/reducers/LogsSlice";
import BasedModal, { IProps } from "../BaseModalComponents/BasedModal";
import {
    Container,
    Input,
    ItemBlock,
    Label,
    ModalBody,
    StyledDatepicker as DatePicker,
    TimeBlock,
    StyledTimepicker as TimePicker,
    SaveButton,
    ListOfTickers,
    ListTickerItem,
    ScrollbarWrapper,
} from "./styles";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../hooks/redux";

const format = "HH:mm";

const style: Styles = {
    overlay: {
        position: "fixed",
        zIndex: 100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
        position: "static",
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        width: "330px",
        padding: 0,
        boxShadow: "0px 0px 5px rgba(49, 69, 49, 0.14)",
        borderRadius: "10px",
    },
};

let inputNotTouchedYet = true;

function CombineLogsModal({ isOpen, onRequestClose }: IProps) {
    const dispatch = useDispatch();
    const { logsToSave } = useAppSelector((state) => state.logs);
    const { ticker_name, start_date, end_date } = logsToSave;
    const currentTickersList: string[] = useAppSelector(
        (state) => state.tabs.addTickerPopup
    );
    const [date, setDate] = useState("");

    const [tickerNameInputIsOpen, setTickerNameInputIsOpen] = useState(false);
    const [currentTickersInputVal, setCurrentTickersInputVal] = useState("");
    const [filteredTickersList, setFilteredTickersList] = useState<string[]>(
        []
    );
    const [inputValueIsValid, setInputValueIsValid] = useState(!!ticker_name);

    // useEffect(() => {
    //     dispatch(getLogs());
    // }, []);

    useEffect(() => {
        const newFilteredTickersList = currentTickersList.filter((name) => {
            if (currentTickersInputVal == "") {
                return true;
            }
            if (
                name
                    .toLocaleLowerCase()
                    .includes(currentTickersInputVal.toLocaleLowerCase()) &&
                name != currentTickersInputVal
            ) {
                return true;
            }
            if (name === currentTickersInputVal) setInputValueIsValid(true);
            return false;
        });

        setFilteredTickersList(newFilteredTickersList);
    }, [currentTickersInputVal, currentTickersList]);

    useEffect(() => {
        setCurrentTickersInputVal(ticker_name);
    }, [ticker_name]);

    const handleChangeTickerName = () => {
        inputNotTouchedYet = false;
        setTickerNameInputIsOpen(true);
    };

    const handleEmptyClick = ({ target }: { target: HTMLElement }) => {
        if (inputValueIsValid && target.nodeName === "DIV") {
            setTickerNameInputIsOpen(false);
        }
    };

    const handleChoseTickerName = (name: string) => {
        setCurrentTickersInputVal(name || "");
        setInputValueIsValid(true);
        setTickerNameInputIsOpen(false);
    };

    const onNameTickerInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValueIsValid(false);
        setCurrentTickersInputVal(event.target?.value);
    };

    const onSaveLogs = (event: React.MouseEvent) => {
        dispatch(setLogsTickerName(currentTickersInputVal));
        dispatch(combineLogs());

        if (onRequestClose) {
            onRequestClose(event);
        }
    };

    const onChangeDate = (date: Moment, dateString: string) => {
        setDate(dateString);
        if (!dateString) {
            dispatch(setLogsStartDate(""));
            dispatch(setLogsEndDate(""));
        }
    };

    const onChangeStartTime = (_: Moment, dateString: string) => {
        if (!dateString) {
            dispatch(setLogsStartDate(""));
            return;
        }
        dispatch(setLogsStartDate(`${date}T${dateString}`));
    };

    const onChangeEndTime = (_: Moment, dateString: string) => {
        if (!dateString) {
            dispatch(setLogsEndDate(""));
            return;
        }
        dispatch(setLogsEndDate(`${date}T${dateString}`));
    };
    useEffect(() => {
        //@ts-ignore
        dispatch(getLogs());
    }, []);

    return (
        <BasedModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={style}
        >
            <Container>
                <ModalBody onClick={handleEmptyClick}>
                    <ItemBlock>
                        <Label>Имя тикера</Label>
                        <Input
                            isValid={inputNotTouchedYet || inputValueIsValid}
                            onFocus={handleChangeTickerName}
                            value={currentTickersInputVal}
                            placeholder="Введите имя тикера"
                            onChange={onNameTickerInput}
                        />
                        {tickerNameInputIsOpen && (
                            <ScrollbarWrapper>
                                <ListOfTickers
                                    style={{
                                        height: `${
                                            filteredTickersList.length < 3
                                                ? `${
                                                      filteredTickersList.length *
                                                      40
                                                  }px`
                                                : "119px"
                                        }`,
                                    }}
                                >
                                    {filteredTickersList.map((name) => {
                                        return (
                                            <ListTickerItem
                                                onClick={handleChoseTickerName.bind(
                                                    null,
                                                    name
                                                )}
                                                key={name}
                                            >
                                                {name}
                                            </ListTickerItem>
                                        );
                                    })}
                                </ListOfTickers>
                            </ScrollbarWrapper>
                        )}
                    </ItemBlock>
                    <ItemBlock>
                        <Label>Дата</Label>
                        <DatePicker
                            onChange={onChangeDate}
                            popupStyle={{
                                zIndex: 101,
                            }}
                        />
                    </ItemBlock>
                    <TimeBlock>
                        <ItemBlock>
                            <Label>Время начала</Label>
                            <TimePicker
                                disabled={!date}
                                onChange={onChangeStartTime}
                                placeholder="00:00"
                                format={format}
                            />
                        </ItemBlock>
                        <ItemBlock>
                            <Label>Время конца</Label>
                            <TimePicker
                                disabled={!date || !start_date}
                                onChange={onChangeEndTime}
                                placeholder="00:00"
                                format={format}
                            />
                        </ItemBlock>
                    </TimeBlock>
                    <SaveButton
                        onClick={onSaveLogs}
                        disabled={
                            !date ||
                            !inputValueIsValid ||
                            !start_date ||
                            !end_date
                        }
                    >
                        Свести логи
                    </SaveButton>
                </ModalBody>
            </Container>
        </BasedModal>
    );
}

export default CombineLogsModal;
